// extracted by mini-css-extract-plugin
module.exports = {"ImagePlaceholder":"ImagePlaceholder_ImagePlaceholder__3x81t"};